import { render, staticRenderFns } from "./SignUpProviderPopup.vue?vue&type=template&id=46331e00&"
import script from "./SignUpProviderPopup.vue?vue&type=script&lang=js&"
export * from "./SignUpProviderPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports